export default __webpack_public_path__ + "static/media/nutri.7c6c6872.jpg";